import { render, staticRenderFns } from "./DebugTools.vue?vue&type=template&id=15f72da2&"
import script from "./DebugTools.vue?vue&type=script&lang=js&"
export * from "./DebugTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports